import Draggable from 'gsap/Draggable';
import vars from './vars';
import router from './router';

function draggableToHome() {
	let $hash = vars.$hashItem.filter('.is-move');

	new TimelineMax({
		onComplete() {
			$hash.removeClass('is-move');
			vars.$hashArea.removeClass('is-active');
		},
	})
		.to($hash, 0.5, {
			x: 0,
			y: 0,
		});
}

Draggable.create(vars.$hashItem, {
	type: 'x, y',
	edgeResistance: 0.65,
	cursor: 'pointer',
	throwProps: true,
	force3D: true,
	onDragStart(e) {
		vars.$document.trigger('tag-drag', $(e.target).text());
	},
	onDrag() {
		let circleOffset = vars.$hashArea.offset();
		let circleWidth = vars.$hashArea.width();
		let circleHeight = vars.$hashArea.height();

		$(this.target).addClass('is-move');

		if (
			this.pointerX > circleOffset.left && this.pointerX < circleOffset.left + circleWidth &&
			this.pointerY > circleOffset.top && this.pointerY < circleOffset.top + circleHeight
		) {
			vars.$hashArea.addClass('is-active');
		} else {
			vars.$hashArea.removeClass('is-active');
		}
	},
	onDragEnd(e) {
		let draggableTarget = $(e.target);

		if (vars.$hashArea.hasClass('is-active')) {
			let url = draggableTarget.data('href');

			if (url.match('/article/')) {
				router.navigate(url);
				vars.$document.trigger('tag-drop', $(e.target).text());
			} else {
				window.open(url, '_blank');
				vars.$document.trigger('tag-drop-dex');
			}

			setTimeout(() => {
				draggableToHome();
			}, 1000);
		} else {
			draggableToHome();
		}
	},
	onClick(e) {
		let url = $(e.target).data('href');

		if (url.match('/article/')) {
			router.navigate(url);
			vars.$document.trigger('tag-click', $(e.target).text());
		} else {
			window.open(url, '_blank');
			vars.$document.trigger('tag-click-dex');
		}
	},
});
